import { QueryResources } from 'datx-jsonapi-react';

import { ResourceType } from '@/enums/ResourceType';
import { Notification } from '@/resources/Notification';

export const queryEventChatChannelNotifications = (eventId: string): QueryResources<Notification> => {
  return [
    Notification,
    {
      filter: {
        event_id: eventId,
        scope: 'unread',
        resource_type: ResourceType.EventChatChannel,
      },
    },
  ];
};

export const queryChatChannelNotification = (channelId: string): QueryResources<Notification> => {
  return [
    Notification,
    {
      filter: {
        // event_id: eventId,
        scope: 'unread',
        resource_type: ResourceType.EventChatChannel,
        event_chat_channel_id: channelId,
      },
    },
  ];
};
